export default {
    secure_checkout: 'Pago Seguro',
    cart: 'Carrito',
    photos: 'fotos',
    see_all: 'Ver todas',
    subscription: 'Suscripción',
    sold_out: 'Agotado',
    subtotal: 'Subtotal',
    discount: 'Descuento',
    shipping: 'Envío',
    free: 'gratis',
    total: 'Total',
    recurring_info: '* Monto recurrente según el plan',
    description: 'Descripción',
    has_coupon: '¿Tienes un cupón de descuento? Haz clic aquí.',
    enter_coupon: 'Ingresa el cupón',
    apply: 'Aplicar',
    personal_data: 'Datos Personales',
    full_name: 'Nombre Completo*',
    required_field: 'Este campo es obligatorio',
    review_form: 'Revisa los campos destacados para finalizar la compra.',
    email: 'Email*',
    phone: 'Teléfono*',
    document: 'Documento*',
    continue: 'Continuar',
    shipping_data: 'Datos de Envío',
    zipcode: 'Código Postal*',
    street: 'Dirección*',
    number: 'Número*',
    complement: 'Complemento',
    neighborhood: 'Barrio*',
    city: 'Ciudad*',
    state: 'Estado/Provincia*',
    back: 'Volver',
    payment_method: 'Método de Pago',
    credit_card: 'Tarjeta de Crédito',
    billet: 'Boleto',
    pix: 'Pix',
    card_number: 'Número de Tarjeta*',
    card_name: 'Nombre en la tarjeta*',
    expiry_month: 'Mes de Vencimiento*',
    expiry_year: 'Año de Vencimiento*',
    security_code: 'Código de Seguridad (CVV)*',
    security_code_short: 'Cód. Seguridad*',
    installments: 'Cuotas*',
    product_not_found: 'Producto no encontrado',
    product_not_found_msg: 'Lamentablemente no encontramos el producto que buscabas.',
    buy_now: 'Comprar Ahora',
    generate_billet: 'Generar Boleto',
    pay: 'Pagar',
    pix_payment: 'Pago vía Pix',
    billet_payment: 'Pago vía Boleto',
    copy_code: 'Copiar código Pix',
    copied: '¡Copiado!',
    billet_no_installments: 'No es posible pagar en cuotas un Boleto.',
    pay_until_due_date: 'Paga hasta la fecha de vencimiento',
    billet_due_date_warning:
        'Presta atención al vencimiento del Boleto. Puedes pagarlo en cualquier banco o casa de lotería hasta su vencimiento.',
    wait_payment_approval: 'Espera la aprobación del pago',
    billet_approval_time: 'Los pagos con Boleto tardan hasta 3 días hábiles en compensarse y liberar los productos.',
    pix_payment_instructions: 'Usa la aplicación de tu banco para hacer un pago con PIX. ¡Es rápido y fácil!',
    instant_payment: 'Pago Instantáneo',
    pix_approval_time: 'Los pagos con Pix se procesan al instante, ¡pero algunos bancos pueden tardar unos minutos!',
    credit_card_fees: 'Tarifa de cuotas de 2.99% en tarjetas de crédito.',
    exclusive_offer_available: 'oferta exclusiva disponible',
    exclusive_offers_available: 'ofertas exclusivas disponibles',
    for_you: 'para ti:',
    get_offer: 'Tomar oferta',
    remove_offer: 'Quitar oferta',
    offer_acquired: 'Oferta Adquirida',
    cart_has_sold_out_product: 'Tienes un producto agotado en tu carrito, quítalo para finalizar.',
    loading: 'Cargando',
    hoopay_processing: 'HooPay está procesando este pago para el vendedor',
    type_discount_coupon: 'Ingresa un Cupón de Descuento',
    type_full_name: 'Ingresa tu Nombre Completo',
    type_email: 'Ingresa tu Email',
    type_phone: 'Ingresa tu Número de Celular',
    type_document: 'Ingresa tu Documento',
    type_zipcode: 'Ingresa tu Código Postal',
    type_street: 'Ingresa tu Dirección Completa',
    type_number: 'Ingresa el número de tu dirección',
    type_neighborhood: 'Ingresa tu Barrio',
    type_city: 'Ingresa tu Ciudad',
    invalid_cpf: 'CPF/Documento inválido',
    invalid_cnpj: 'CNPJ/Documento inválido',
    invalid_email: 'Este email es inválido',
    generate_pix: 'Generar PIX',
    finish_payment: 'Finalizar',
    order_observations: 'Observaciones de tu pedido',
    order_observations_placeholder:
        'Detalles del producto, nombre del vendedor, instrucciones de entrega u otras observaciones',
    recaptcha_protected: 'Este sitio está protegido por Google reCAPTCHA',
    privacy_policy_terms: 'Política de privacidad y Términos de servicio',
    agree_terms: 'Al continuar, aceptas los Términos de Compra',
    choose_shipping: 'Elige una opción de envío',
    cannot_complete_purchase: 'Por el momento no es posible completar esta compra',
    ok_got_it: 'Ok, entiendo',
    countdown_finished: 'Tu tiempo ha terminado, adquiere tu acceso ahora mismo.',
    promotional_price_ending: '¡No pierdas esta oportunidad! El precio promocional finalizará pronto..',
    privacy_policy: 'Política de privacidad',
    terms_of_service: 'Términos de servicio',
    installments_with_addition: '* Cuotas con recargo',
    and: 'y',
    order_analyzing: 'Pedido en análisis',
    transaction_safety_analysis: 'Su transacción está pasando por un análisis de seguridad.',
    safety_protocol_info:
        'Descanse tranquilo, esto es parte de nuestros protocolos de seguridad. Pronto se actualizará el estado de su pedido y recibirá una notificación.',
    awaiting_payment: 'Esperando el pago',
    complete_purchase_payment: 'Realice el pago para completar su compra',
    pix_code: 'Código PIX',
    already_paid: 'Ya realicé el pago',
    how_to_pay_pix: 'Cómo pagar con PIX',
    open_bank_app: 'Abra la aplicación de su banco',
    open_bank_app_desc: 'Acceda a la aplicación de su banco o institución financiera',
    choose_pix_option: 'Elija la opción PIX',
    choose_pix_option_desc: 'Seleccione la opción PIX en el menú principal de la aplicación',
    scan_qr_copy_code: 'Escanee o copie el código QR',
    scan_qr_copy_code_desc: 'Utilice la cámara para leer o pegue el código QR copiado',
    confirm_payment_step: 'Confirmar pago',
    confirm_payment_step_desc: 'Verifique los datos y confirme la transacción',
    pix_code_copied: '¡Código PIX copiado con éxito!',
    copy_error: 'Error al copiar el código',
    payment_not_identified: 'Pago no identificado',
    billet_instructions: 'Instrucciones',
    billet_after_expiration_warning: 'Después del vencimiento, emitir un nuevo boleto.',
    billet_do_not_accept_after_expiration: 'No aceptar pago después del vencimiento.',
    billet_request_new_copy: 'En caso de vencimiento, solicitar una nueva copia.',
    billet_support_doubts: '¿Dudas? Contacte con nuestro soporte.',
    print_billet: 'Imprimir Boleto',
    payer_receipt: 'Recibo del Pagador',
    payment_location: 'Lugar de Pago',
    beneficiary_name_label: 'Nombre del Beneficiario / CNPJ / CPF / Dirección:',
    doc_date: 'Fecha del documento',
    doc_number: 'Núm. del documento',
    doc_type: 'Especie doc',
    acceptance: 'Aceptación',
    processing_date: 'Fecha de Procesamiento',
    our_number: 'Nuestro Número',
    bank_use: 'Uso del Banco',
    wallet: 'Cartera',
    currency: 'Especie',
    quantity: 'Cantidad',
    value: 'Valor',
    doc_value_label: '(=) Valor del Documento',
    discounts_label: '(-) Descuentos/Abatimientos',
    interest_fine_label: '(+) Interés/Multa',
    paid_value_label: '(=) Valor Pagado',
    payer_name: 'Nombre del Pagador:',
    beneficiary_drawee: 'Girador/Avalista:',
    address: 'Dirección',
    website: 'Sitio web',
    expiry_date: 'Vencimiento',
    agency_code_label: 'Agencia / Código del Beneficiario',
    mechanical_authentication: 'Autenticación Mecánica',
    compensation_slip: 'Ficha de Compensación',
    amount_to_pay: 'Monto a pagar',
    due_date: 'Vencimiento',
    billet_code: 'Línea Digitável',
    copy_code_tip: 'Copie el código de arriba para pagar en la aplicación de su banco',
    download_view_pdf: 'Descargar/Ver PDF',
    payment_instructions: 'Instrucciones de Pago',
    billet_step_1_title: 'Copie el código o descargue el PDF',
    billet_step_1_desc: 'Utilice la línea digitável o imprima el boleto para pagar.',
    billet_step_2_title: 'Pague en su banco',
    billet_step_2_desc: 'Use la aplicación de su banco o vaya a una sucursal/lotería.',
    billet_step_3_title: 'Espere la confirmación',
    billet_step_3_desc: 'El plazo de compensación es de hasta 3 días hábiles.',
    billet_code_copied: '¡Código copiado con éxito!',
    copy_error_billet: 'Error al copiar el código',
    security_validation: 'Validación de Seguridad',
    security_validation_desc:
        'Para su protección, confirme el documento registrado en el pedido para ver los detalles.',
    validating: 'Validando...',
    view_order: 'Ver Pedido',
    document_not_found: 'Documento no encontrado para este pedido',
    validation_error: 'Error de validación. Verifique el documento.',
    your_content: 'Tu Contenido',
    acquired_materials_description: 'A continuación se detallan todos los materiales que ha adquirido',
    search_content: 'Buscar contenido...',
    external_link: 'Enlace Externo',
    download: 'Descargar',
    open_link: 'Abrir Enlace',
    view: 'Visualizar',
    no_content_found: 'No se encontró contenido',
    try_changing_filters: 'Intente cambiar los filtros o los términos de búsqueda.',
    browser_no_video_support: 'Su navegador no soporta el elemento de video.',
    all: 'Todos',
    images: 'Imágenes',
    videos: 'Videos',
    documents: 'Documentos',
    links: 'Enlaces',
    image_file: 'Archivo de imagen',
    video_file: 'Archivo de video',
    download_document: 'Documento para descargar',
    download_file: 'Archivo para descargar',
    file: 'Archivo',
    product_not_found_msg_detailed:
        'No pudimos encontrar el producto. Por favor, póngase en contacto con el vendedor para obtener más información.',
    order_refunded: 'Pedido Reembolsado',
    order_refunded_msg: 'El importe de su pedido ha sido devuelto.',
    order_refunded_description:
        'La transacción de reembolso se completó con éxito. El importe se abonará en la misma cuenta o factura utilizada para el pago.',
    identifier: 'Identificador',
    loading_payment_info: 'Cargando información de pago...',
    oops_something_wrong: '¡Vaya! Algo salió mal',
    order: 'Pedido',
    unrecognized_payment_type: 'Tipo de pago no reconocido',
    uuid_not_provided: 'UUID del pedido no proporcionado',
    order_not_found_check_uuid: 'Pedido no encontrado. Compruebe si el UUID é correcto.',
    error_loading_payment_try_again: 'Error al cargar los datos de pago. Inténtelo de nuevo más tarde.',
    payment_successful: '¡Pago realizado!',
    order_info: 'Información del Pedido',
    order_number: 'Número',
    loading_items: 'Cargando artículos...',
    date: 'Fecha',
    customer_data: 'Datos del Cliente',
    cpf: 'Documento',
    phone_label: 'Teléfono',
    shipping_address: 'Dirección de Envío',
    support: 'Soporte',
    select_shipping_option: 'Seleccione una opción de envío',
    delivery: 'Entrega',
    days: 'días',
    business_days: 'días hábiles',
    until: 'Hasta',
    today: 'hoy',
    order_delivery_forecast: 'Su pedido será entregue',
    between: 'entre',
    invalid_zipcode: '¡Código postal inválido!',
    transaction_not_completed: 'Transacción no completada',
    payment_failed_gateway: 'El pago falló en la pasarela. Verifique sus datos o intente con otro método.',
    payment_status: 'Estado del pago',
    // motivo del rechazo de la tarjeta (charges[].errorMessage.reason)
    captcha: {
        hint: 'Confirma la verificación de seguridad para finalizar el pago.',
        error: 'No fue posible completar la verificación de seguridad. Inténtalo de nuevo.',
    },
    billing_address: {
        title: 'Dirección de facturación (opcional)',
        hint: 'Informar la dirección del titular de la tarjeta aumenta las posibilidades de aprobación.',
        zipcode: 'Código postal',
        street: 'Dirección (calle, avenida, etc.)',
        number: 'Número',
        neighborhood: 'Barrio',
        city: 'Ciudad',
        state: 'Estado',
    },
    charge_recovery: {
        pay_with_pix: 'Pagar con PIX',
        pay_with_pix_hint: 'Generamos el PIX al instante con los mismos datos, sin necesidad de escribir nada.',
        fix_cc_securityCode: 'Corregir el código de seguridad',
        fix_cc_expiryMonth: 'Corregir la fecha de vencimiento',
        fix_cc_number: 'Corregir el número de la tarjeta',
    },
    charge_error: {
        insufficient_funds: {
            title: 'Saldo o límite insuficiente',
            hint: 'Verifique el límite disponible de su tarjeta o intente con otra tarjeta.',
        },
        invalid_cvv: {
            title: 'Código de seguridad inválido',
            hint: 'Verifique el código de seguridad (CVV) al dorso de la tarjeta e intente nuevamente.',
        },
        expired_card: {
            title: 'Tarjeta vencida',
            hint: 'Verifique la fecha de vencimiento o utilice otra tarjeta.',
        },
        invalid_card_data: {
            title: 'Datos de la tarjeta inválidos',
            hint: 'Verifique el número, el vencimiento y el nombre del titular e intente nuevamente.',
        },
        card_blocked: {
            title: 'Tarjeta bloqueada o con restricción',
            hint: 'Comuníquese con el banco emisor o utilice otra tarjeta.',
        },
        transaction_not_allowed: {
            title: 'Compra no permitida para esta tarjeta',
            hint: 'Es posible que su tarjeta no esté habilitada para compras en línea. Consulte a su banco o utilice otra tarjeta.',
        },
        issuer_declined: {
            title: 'Pago rechazado por el banco',
            hint: 'El banco emisor no autorizó la compra. Comuníquese con él o utilice otra tarjeta.',
        },
        suspected_fraud: {
            title: 'No fue posible validar la compra',
            hint: 'Por seguridad, la compra no fue aprobada. Intente con otra tarjeta u otro medio de pago.',
        },
        attempts_exceeded: {
            title: 'Límite de intentos excedido',
            hint: 'Espere unos minutos e intente nuevamente, o utilice otra tarjeta.',
        },
        invalid_amount: {
            title: 'Monto no permitido en la tarjeta',
            hint: 'Intente con otro medio de pago.',
        },
        try_again: {
            title: 'Inestabilidad en el procesamiento',
            hint: 'No fue posible completar ahora. Espere unos instantes e intente nuevamente.',
        },
        generic: {
            title: 'Pago no autorizado',
            hint: 'Verifique los datos de la tarjeta o intente con otra tarjeta u otro medio de pago.',
        },
        payment_unavailable: {
            title: 'No fue posible generar el pago',
            hint: 'Intente nuevamente en unos instantes o elija otro medio de pago.',
        },
    },
    weekly: 'semanal',
    biweekly: 'quincenal',
    monthly: 'mensual',
    quarterly: 'trimestral',
    semiannual: 'semestral',
    yearly: 'anual',
    product_added_to_cart: 'Producto añadido al carrito',
    error_processing_payment: 'Error al procesar el pago',
    offer_removed: 'Oferta eliminada',
    convert_to: 'Convertir en:',
    currency_brl: 'Real brasileño (R$)',
    currency_usd: 'Dólar americano ($)',
    currency_eur: 'Euro (€)',
};
